import {gql} from "@apollo/client";

export default gql`
    fragment MentorFieldsFull on MentorFields {
        primaryFlag {
            name
            code
        }
        secondaryFlag {
            name
            code
        }
    }
`;
